export default "__VITE_ASSET__17GqKQox__"